'use strict';
import template from './accounts.html';
import Account from './../../lib/models/Account.js';

//Instantiate Page Variables
var AccountsPageViewModel = function(page)
{
	this.page = page;
}

//Handle interaction with page
var AccountsPage = function(bindings) {
	this.bindings = bindings;
	this.viewModel = new AccountsPageViewModel(this);
	this.name = 'Accounts';

	//Event (Post/After): Load once
	this.init = function() {
		document.title = this.name;

		let actions_formatter = function(value, row, index) {
			return	`
			<button class="btn btn-warning btn-xs account-edit" title="Edit Account">
				<span class="fa fa-pencil"></span>
			</button>
			<button class="btn btn-danger btn-xs account-delete" title="Delete Account">
				<span class="fa fa-trash"></span>
			</button>`;
		};

		let actions_events = {
			'click .account-delete': async (e, value, row, index) => {
				let account = new Account(row);
				let response = await account.delete();
				if (response?.status === 'OK')
					this.updateData();
			},
			'click .account-edit': function(e, value, row, index) {
				Grape.alert({title: 'Delete Account', type: 'warning', message: "Not implemented"});
			}
		};

		//COMPONENT: Bootstrap Table
		$("#tbl_table").bootstrapTable({
			columns: [
				{field: 'account_name', title: 'Name', sortable: true, width: ''},
				{field: 'company_name', title: 'Company', sortable: true, width: ''},
				{field: 'username', title: 'Owner Username', sortable: true, width: ''},
				{field: 'email', title: 'Owner Email', sortable: true, width: ''},
				{
					field: 'action',
					width: '',
					align: 'right',
					title: 'Actions',
					formatter: actions_formatter,
					events : actions_events
				}
			],

			dataField: 'records',

			//TABLE PROPERTIES: Paging
			pagination: true,
			pageList: [20, 50, 100],
			pageSize: 20,
			sidePagination: 'server',
			onPageChange: (number, size) => {
				this.updateData();
			},

			//TABLE PROPERTIES: Sort
			sortOrder: 'asc',
			sortName: 'account_name',
			onSort: (sortName, sortOrder) => {
				this.updateData({sort_column: sortName, sort_order: sortOrder});
			},

			//TABLE PROPERTIES: Search
			search: false,
			searchOnEnterKey: true,
			onSearch: (text) => {
				this.updateData();
			}
		});
	};

	//Event (Post/After): Refresh page data
	this.updateData = function() {
		let bt_options = $("#tbl_table").bootstrapTable('getOptions');
		Grape.tables.select(Object.assign(bt_options, {schema:'account', tablename: 'v_accounts'}), function (response) {
			if (response.records == null)
				response.records = [];
			$("#tbl_table").bootstrapTable('load', response);
		});
	};

	//Event (Pre/Before): Remove
	this.teardown = function() {
	};

	this.btnAddAccount_click = (default_values) => {
		default_values = default_values || {};

		Grape.show_dialog(
			'DataInput',
			{
				title: 'Add Account',
				fields:[
					{type: 'text', name: 'company_name', label: 'Company Name', default_value: default_values.company_name || ''},
					{type: 'text', name: 'email', label: 'Email', default_value: default_values.email || ''},
					{type: 'text', name: 'confirm_email', label: 'Confirm Email'},
					{type: 'text', name: 'fullnames', label: 'Fullnames', default_value: default_values.fullnames || ''},
					{type: 'password', name: 'password', label: 'Password'},
					{type: 'password', name: 'confirm_password', label: 'Confirm Password'},
					{type: 'boolean', name: 'is_hashed', label: 'Password is hashed', default_value: default_values.is_hashed || false}
				]
			},
			{
				onClose: (account) => {
					if (!account)
						return;

					if (account.password !== account.confirm_password) {
						Grape.alert({title: 'Account Error', type: 'error', message: "Passwords don't match", onClose:()=>{
							this.btnAddAccount_click(account);
						}});
						return;
					}
					else if (account.email !== account.confirm_email) {
						Grape.alert({title: 'Account Error', type: 'error', message: "Passwords don't match", onClose:()=>{
							this.btnAddAccount_click(account);
						}});
						return;
					}

					$.postJSON('/account/create', account)
					.then((res) => {
						if (res.status === 'OK') {
							Grape.alert({
								title: 'Account Added',
								type: 'success',
								message: "Account successfully added. You will receive an email with the account details shortly."
							});
							this.updateData();
						} else {
							res.onClose = ()=>{
								this.btnAddAccount_click(account);
							};
							Grape.alert_api_error(res);
						}
					});
				}
			}
		);
	};

	this.btnAddSavannaAccount_click = (default_values) => {
		default_values = default_values || {};

		Grape.show_dialog(
			'DataInput',
			{
				title: 'Add Account',
				fields:[
					{type: 'text', name: 'company_name', label: 'Company Name', default_value: default_values.company_name || ''},
					{type: 'text', name: 'email', label: 'Email', default_value: default_values.email || ''},
					{type: 'text', name: 'confirm_email', label: 'Confirm Email'},
					{type: 'text', name: 'contact_number', label: 'Contact Number', default_value: default_values.contact_number || ''},
					{type: 'text', name: 'confirm_contact_number', label: 'Confirm Contact Number'},
					{type: 'text', name: 'fullnames', label: 'Username', default_value: default_values.fullnames || ''},
					{type: 'password', name: 'password', label: 'Password'},
					{type: 'password', name: 'confirm_password', label: 'Confirm Password'}
				]
			},
			{
				onClose: (account) => {
					if (!account)
						return;

					if (account.password !== account.confirm_password) {
						Grape.alert({title: 'Account Error', type: 'error', message: "Passwords don't match", onClose:()=>{
							this.btnAddSavannaAccount_click(account);
						}});
						return;
					}
					else if (account.email !== account.confirm_email) {
						Grape.alert({title: 'Account Error', type: 'error', message: "Emails don't match", onClose:()=>{
							this.btnAddSavannaAccount_click(account);
						}});
						return;
					}
					else if (account.contact_number !== account.confirm_contact_number) {
						Grape.alert({title: 'Account Error', type: 'error', message: "Contact numbers don't match", onClose:()=>{
							this.btnAddSavannaAccount_click(account);
						}});
						return;
					}

					// included in api from hr staff hub site
					account.product_code = 'savanna';
					account.features = ["free", null, null, null, null];

					$.postJSON('/account/create', account)
					.then((res) => {
						if (res.status === 'OK')
							Grape.alert({
								title: 'Account Added',
								type: 'success',
								message: "Account successfully added. You will receive an email with the account details shortly."
							});
						else {
							res.onClose = ()=>{
								this.btnAddSavannaAccount_click(account);
							};
							Grape.alert_api_error(res);
						}
					});
				}
			}
		);
	};

};

export default {
	route: '[/]admin/accounts',
	page_class: AccountsPage,
	template: template
};
